import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 141 79" {...props}><path fill="currentColor" stroke="currentColor" d="M2.9 14.5C-4.6 7 7-4.7 14.5 2.8l56 56 56-56c7.5-7.5 19.1 4.1 11.6 11.6L76.3 76.2c-3.2 3.1-8.4 3.1-11.6 0L2.9 14.5z" /></svg>);